module.exports = __webpack_public_path__ + "img/history1.2c121661.png";